import React, { useEffect, useState } from "react";
import { FaCalendarAlt, FaPlus, FaTimes } from "react-icons/fa";
import { FaClock, FaGift, FaHourglass } from "react-icons/fa6";
import { GiHourglass } from "react-icons/gi";
import { Link } from "react-router-dom";

const EventTimerCard = ({ event, user }) => {
  const [now, setNow] = useState(new Date());
  const [status, setStatus] = useState("loading"); // 'before' | 'running' | 'ended'
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const current = new Date();
      setNow(current);
      updateStatus(current);
    }, 1000);
    return () => clearInterval(interval);
  }, [event]);

  const updateStatus = (current) => {
    const start = new Date(event.start_time);
    const end = new Date(event.end_time);

    if (current < start) {
      setStatus("before");
      setTimeLeft(formatTime(start - current));
    } else if (current >= start && current <= end) {
      setStatus("running");
      setTimeLeft(formatTime(end - current));
    } else {
      setStatus("ended");
    }
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const rewardIcon = "/gold.png";

  const statusStyle = {
    before: "bg-yellow-500 text-black",
    running: "bg-green-500 text-black",
    ended: "bg-red-500 text-white",
  };

  return (
    <div className=" bg-gradient-to-br from-[#1e3a8a] to-[#0f172a] text-white rounded-3xl shadow-lg p-6 mb-10 border border-white/10 relative overflow-hidden">
      <div className="flex justify-center lg:justify-between items-center gap-4 flex-wrap">
        <div className="flex items-start gap-4">
          <FaCalendarAlt className="min-w-8 text-3xl lg:text-5xl text-yellow-600 animate-pulse mt-2" />
          <div>
            <h3 className="text-2xl font-bold">{event.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: event.desc }} />
            <div className="flex items-center gap-2 text-lg mt-1">
              <img src={rewardIcon} alt="reward" className="w-6 h-6" />
              <span className="font-semibold flex items-center">
                {event.rewardType === "times" ? "*" : "+"} {event.reward}
              </span>
            </div>
          </div>
        </div>
        <div className="text-right min-w-[150px] flex gap-2 items-center">
          {status === "running" && (
            <Link
              to={"https://buy.filetrust.io?user=" + user?._id}
              target="_blank"
              className={`rounded-full px-4 py-2 text-sm font-bold shadow-md inline-block bg-blue-600`}
            >
              Start
            </Link>
          )}
          {status !== "ended" && (
            <div
              className={`rounded-full px-4 py-2 text-sm font-bold shadow-md inline-block ${statusStyle[status]}`}
            >
              {status === "before" ? "Starts in" : "Ends in"}
              <span className="ml-2">
                <FaClock className="inline mb-[2px] mr-1" />
                {timeLeft}
              </span>
            </div>
          )}
          {status === "ended" && (
            <div className="rounded-full bg-gray-700 px-4 py-2 text-sm font-semibold shadow">
              Event Ended
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventTimerCard;
